import { useEffect, useState } from "react"
import { Button, FormGroup, Input, Label, Modal, ModalBody } from "reactstrap"
import { toast } from "react-toastify"

import Imagem from "components/Imagem"
import { confirm } from "components/Confirmation"
import { alert } from "components/Alert"
import { showLoading, hideLoading } from "components/Loading"
import { erroInesperado } from "services/Utils"
import ordemServicoService from "services/OrdemServicoService"

export default function ModalConferirCorrecao({ config, onClosed, onChange }) {
  const [pendentes, setPendentes] = useState([])
  const [motivos, setMotivos] = useState({})

  useEffect(() => {
    setPendentes(config?.pendentes || [])
    setMotivos({})
  }, [config])

  useEffect(() => {
    if (config && pendentes.length === 0) {
      onClosed && onClosed()
    }
  }, [pendentes])

  const handleAprovar = (correcao) => {
    confirm({
      header: "Aprovar correção",
      text: "Tem certeza que gostaria de aprovar esta correção?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          showLoading()
          await ordemServicoService.aprovarCorrecao(config.idOrdemServico, correcao.id)
          hideLoading()
          toast('Correção aprovada')
          setPendentes(prev => prev.filter(p => p.correcao.id !== correcao.id))
          onChange && onChange()
        } catch (ex) {
          hideLoading()
          erroInesperado()
        }
      }
    })
  }

  const handleReprovar = (correcao) => {
    const motivo = (motivos[correcao.id] || '').trim()
    if (motivo.length < 3) {
      alert({ text: 'Informe o motivo da reprovação (mínimo 3 caracteres).' })
      return
    }

    confirm({
      header: "Reprovar correção",
      text: "Tem certeza que gostaria de reprovar esta correção?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          showLoading()
          await ordemServicoService.reprovarCorrecao(config.idOrdemServico, correcao.id, motivo)
          hideLoading()
          toast('Correção reprovada')
          setPendentes(prev => prev.filter(p => p.correcao.id !== correcao.id))
          onChange && onChange()
        } catch (ex) {
          hideLoading()
          erroInesperado()
        }
      }
    })
  }

  return (
    <Modal isOpen={!!config} size="lg">
      <ModalBody>
        <h2>Conferir Correção</h2>
        <div className="text-dark mb-2">
          {config?.item?.codigo} - {config?.item?.descricao}
        </div>
        <hr />
        <div className="d-flex flex-column" style={{ gap: 16 }}>
          {pendentes.map(({ divergencia, correcao }) => (
            <div className="border rounded p-3 d-flex flex-column" style={{ gap: 8 }} key={correcao.id}>
              <div><strong>Divergência lançada:</strong></div>
              <div>{divergencia.observacao}</div>
              <div className="d-flex flex-wrap" style={{ gap: 5 }}>
                {divergencia.fotos.map(el => (
                  <Imagem key={el.id} url={el.url} urlThumb={el.urlThumb} dadosLocalizacao={el.dadosLocalizacao} tituloModal="Divergência" />
                ))}
              </div>
              <hr style={{ marginTop: 0, marginBottom: 0 }} />
              <div><strong>Correção lançada pela empresa executora:</strong></div>
              <div>{correcao.observacao}</div>
              <div className="d-flex flex-wrap" style={{ gap: 5 }}>
                {correcao.fotos.map(el => (
                  <Imagem key={el.id} url={el.url} urlThumb={el.urlThumb} dadosLocalizacao={el.dadosLocalizacao} tituloModal="Correção" />
                ))}
              </div>
              <FormGroup className="mb-0">
                <Label>Motivo da reprovação (obrigatório apenas se for reprovar)</Label>
                <Input
                  type="textarea"
                  rows={2}
                  value={motivos[correcao.id] || ''}
                  onChange={e => setMotivos(prev => ({ ...prev, [correcao.id]: e.target.value }))}
                />
              </FormGroup>
              <div className="d-flex flex-row justify-content-end" style={{ gap: 8 }}>
                <Button color="danger" outline onClick={() => handleReprovar(correcao)}>Reprovar</Button>
                <Button color="success" onClick={() => handleAprovar(correcao)}>Aprovar</Button>
              </div>
            </div>
          ))}
        </div>
        <div className="text-right mt-4">
          <Button type="button" color="primary" outline onClick={onClosed}>Fechar</Button>
        </div>
      </ModalBody>
    </Modal>
  )
}
